<ng-container *ngIf="decision_table?.framework.analysis_type">
  <app-multiobjective-responses-weight-criteria *ngIf="getAnalysisService().isMultiobjectiveByType(decision_table?.framework.analysis_type)" [evaluationSessionId]="id" [allDecisionInfo]="allInfo" (responseWeightCriteriaSavedEvent)="weightCriteriaSaved()"></app-multiobjective-responses-weight-criteria>
</ng-container>

<ng-container *ngIf="decision_table?.framework.analysis_type">
  <app-multicriteria-responses-weight-criteria *ngIf="getAnalysisService().isMulticriteriaByType(decision_table?.framework.analysis_type)" [evaluationSessionId]="id" [allDecisionInfo]="allInfo" (responseWeightTargetSavedEvent)="weightTargetSaved()"></app-multicriteria-responses-weight-criteria>
</ng-container>

<!-- Non ci sono pesi dei criteri per la consensus -->
